<div class="modal-container">
    <div class="modal-content">
        <div class="modal-header">
            <h1>Schedule Availability</h1>
            <span class="status" [ngClass]="userStatus.toLowerCase()">{{userStatus}}</span>
        </div>
        <div style="margin-top: 15px">
            <h3>Upcoming Events</h3>
        </div>
        <div class="schedule-unavailability-container">

            <form [formGroup]="scheduleForm">
                <div formArrayName="schedules">
                    <ng-container *ngFor="let group of schedules.controls; let i = index">
                    <div *ngIf="group.get('isActive')?.value !== false" [formGroupName]="i"
                        class="schedule-unavailability-item-container">

                        <!-- DELETE -->
                        <button mat-icon-button (click)="removeSchedule(i)">
                            <mat-icon style="color: var(--UI-Red, #900606); margin-top: -12px;">delete</mat-icon>
                        </button>

                        <!-- START TIME PICKER -->
                        <mat-form-field appearance="fill" style="width: 50%;">
                            <mat-label>Unavailable From</mat-label>
                            <input matInput 
                                [ngxMatDatetimePicker]="startPicker" 
                                formControlName="startTime"
                                [min]="getMinimum(group)"
                                (keydown.enter)="$event.preventDefault()" />

                            <ngx-mat-datetime-picker #startPicker  
                                [showButtons]="false" 
                                [enableMeridian]="true" 
                                [stepHour]="1" 
                                [stepMinute]="5">
                            </ngx-mat-datetime-picker>

                            <button mat-icon-button matSuffix (click)="startPicker.open()" tabindex="-1"
                                aria-label="Open Unavailable startTime picker">
                                <mat-icon>today</mat-icon>
                            </button>

                            <mat-error *ngIf="group.get('startTime')?.hasError('pastDateTime') && group.get('startTime')?.touched">
                                Time cannot be in the past.
                            </mat-error>
                        </mat-form-field>

                        <!-- END TIME PICKER -->
                        <mat-form-field appearance="fill" style="width: 50%;">
                            <mat-label>Unavailable To</mat-label>
                            <input matInput 
                                    [ngxMatDatetimePicker]="endPicker" 
                                    formControlName="endTime"
                                    [min]="group.get('startTime')?.value" 
                                    (keydown.enter)="$event.preventDefault()" />

                            <ngx-mat-datetime-picker #endPicker 
                                                    [showButtons]="true" 
                                                    [enableMeridian]="true"
                                                    [stepHour]="1" 
                                                    [stepMinute]="5"></ngx-mat-datetime-picker>

                            <button mat-icon-button matSuffix (click)="endPicker.open()" tabindex="-1"
                                aria-label="Open Unavailable endTime picker">
                                <mat-icon>today</mat-icon>
                            </button>

                            <mat-error *ngIf="group.get('endTime')?.hasError('endBeforeStart') && group.get('endTime')?.touched">
                                End time must be after start time
                            </mat-error>
                        </mat-form-field>

                    </div>
                </ng-container>
                </div>

                <button mat-button color="primary" type="button" (click)="addSchedule(null)" class="add-schedule-btn">
                    <mat-icon aria-hidden="false" aria-label="add icon" matSuffix>
                        add
                    </mat-icon>
                    Add
                </button>
            </form>
        </div>
    </div>
    <div class="close-box">
        <button class="cancel-btn" type="button" mat-button color="primary" class="material-default" (click)="cancel()">
            CANCEL
        </button>
        <button class="save-close-btn" type="button" mat-button color="primary" class="material-default"
            (click)="saveAndClose()" [disabled]="scheduleForm.invalid">
            SAVE AND CLOSE
        </button>
    </div>
</div>